import { useTranslation } from "react-i18next";

import DraggableModal from "../layout/DraggableModal/DraggableModal";

const signed = (value) => `${value >= 0 ? "+" : ""}${value}`;
const modifierBreakdown = (result) => {
  if (!result.modifierBreakdown?.length) return "";
  return ` (${result.modifierBreakdown.map((item) => `${item.label} ${signed(item.value)}`).join(", ")})`;
};

const RollResultModal = ({ result, onClose }) => {
  const { t } = useTranslation();
  return (
    <DraggableModal isVisible={Boolean(result)} onClose={onClose} headerText={t("sheet.rollResult")}>
      {result && (
        <div className="roll-modal">
          <strong>{result.label}</strong>
          {result.diceGroups?.length ? result.diceGroups.map((group) => (
            <div key={`${group.label}-${group.diceLabel}`}>{group.label} {group.diceLabel}: {group.rolls.join(" + ")}</div>
          )) : result.rolls ? (
            <div>{result.diceLabel}: {result.rolls.join(" + ")}</div>
          ) : <div>d20: {result.die}</div>}
          <div>{t("sheet.modifier")}: {signed(result.modifier)}{modifierBreakdown(result)}</div>
          {result.multiplier !== 1 && <div>{t("sheet.multiplier")}: &times;{result.multiplier}</div>}
          {(result.details ?? []).map((detail) => <div key={detail.label}>{detail.label}: {detail.value}</div>)}
          <div className="roll-total">{t("sheet.total")}: {result.total}</div>
        </div>
      )}
    </DraggableModal>
  );
};

export default RollResultModal;
